import { AppRouteRecordRaw } from '../types';
import { ETranslationModule } from '@/i18n/translation';

const Body = () => import('@/components/body.vue');
const UserProfile = () => import('@/pages/users/profile/UserProfile.vue');
const UserEdit = () => import('@/pages/users/edit/UserEdit.vue');
const userList = () => import('@/pages/users/lists/userList.vue');
const userCreate = () => import('@/pages/users/create/userCreate.vue');
const UserManagementGuide = () => import('@/pages/users/documentation/UserManagementGuide.vue');

export const usersRoutes: AppRouteRecordRaw[] = [
  {
    path: '/users',
    component: Body,
    meta: {
      breadcrumb: 'Users',
      i18nModules: [ETranslationModule.users],
    },
    children: [
      {
        path: 'profile',
        name: 'usersProfile',
        component: UserProfile,
        meta: {
          title: 'My Profile | ryd Portal',
          headTitle: 'My Profile',
          breadcrumb: 'My Profile',
        },
      },
      {
        path: 'edit',
        name: 'usersEdit',
        component: UserEdit,
        meta: {
          title: 'Edit User | ryd Portal',
          headTitle: 'Edit User',
          breadcrumb: 'Edit User',
        },
      },
      {
        path: 'list',
        name: 'usersList',
        component: userList,
        meta: {
          title: 'User List | ryd Portal',
          breadcrumb: 'User List',
        },
      },
      {
        path: 'create',
        name: 'usersCreate',
        component: userCreate,
        meta: {
          title: ' User Creation | ryd Portal',
          breadcrumb: 'User Creation',
        },
      },
      {
        path: 'guide',
        name: 'userManagementGuide',
        component: UserManagementGuide,
        meta: {
          title: 'User & Role Management Guide | ryd Portal',
          breadcrumb: 'User & Role Management Guide',
          requiresAuth: true,
          requiredUserGroup: ['ryd'],
        },
      },
    ],
  },
];
